stimulusApp.register(
  "faq-anchor",
  class extends Stimulus.Controller {
    #slug
    #top

    connect() {
      const opened = this.element.querySelector(".help-centre--faq-item_opened")
      if (opened) Viewport.scrollTo($(opened))
    }

    capture(event) {
      if (event.target !== this.element) return

      this.#slug =
        this.#openedSlug(event.detail.newFrame) ||
        this.#openedSlug(this.element)
      this.#top = this.#itemFor(this.#slug)?.getBoundingClientRect().top
    }

    compensate(event) {
      if (event.target !== this.element) return

      const item = this.#itemFor(this.#slug)
      const top = this.#top
      this.#slug = undefined
      this.#top = undefined
      if (!item || top === undefined) return

      const delta = item.getBoundingClientRect().top - top
      if (delta !== 0) window.scrollBy({ top: delta, behavior: "instant" })
    }

    #openedSlug(root) {
      return root.querySelector(".help-centre--faq-item_opened")?.dataset
        .questionSlug
    }

    #itemFor(slug) {
      return slug
        ? this.element.querySelector(`[data-question-slug="${slug}"]`)
        : null
    }
  },
)
